import { gql } from '@apollo/client';

/**
 *  Object Parameters 
 {
  "accomplishmentId": "61a02e1081f86d8fd687cd0d"
}
 */
export const GetAccomplishmentById = gql`
  mutation GetAccomplishmentById($accomplishmentId: ObjectId!) {
    getAccomplishmentById(accomplishmentId: $accomplishmentId) {
      _id
      title
      type
      quantity
      cover
      status
      reached
      disable
    }
  }
`;

/**
 *  Object Parameters 
{
  "createAccomplishmentInput": {
    "title": "",
    "type": "",
    "quantity": 1,
    "cover": "",
    "status": true,
    "disable": false
  }
}
 */

export const CreateAccomplishment = gql`
  mutation CreateAccomplishment($input: CreateAccomplishmentInput!) {
    createAccomplishment(input: $input)
  }
`;

/**
 *  Object Parameters 
  {
  "updateAccomplishmentInput": {
    "_id": "",
    "data": {
      "title": "",
      "type": "category",
      "quantity": 1,
      "cover": "",
      "status": true,
      "disable": false
    }
  }
}
 
 */

export const UpdateAccomplishment = gql`
  mutation UpdateAccomplishment($input: UpdateAccomplishmentInput!) {
    updateAccomplishment(input: $input)
  }
`;

/**
 *  Object Parameters 
{
  "accomplishmentId": null
}
 */

export const DeleteAccomplishment = gql`
  mutation DeleteAccomplishment($id: ObjectId!) {
    deleteAccomplishment(id: $id)
  }
`;
